function openMopinionDialog() {
  var id = "972d6d8a5u7kusdmalbkijkpzkdi7rhd20o";
  var js = document.createElement("script");
  var style = document.createElement("style");
  style.setAttribute("type", "text/css")
  js.setAttribute("type", "text/javascript");
  js.setAttribute("src", "//deploy.mopinion.com/js/pastease.js");
  style.innerHTML = '\n  iframe#surveyWindow {\n    height: 600px !important;\n  }';
  document.getElementsByTagName("head")[0].appendChild(js);
  document.getElementsByTagName("head")[0].appendChild(style);
  var t = setInterval(function () {
    try {
      new Pastease.load(id);
      clearInterval(t)
    } catch (e) {
    }
  }, 50)
}
